export default "__VITE_ASSET__DMe1dRjX__"